
// import axios from 'axios';
// import { API_ADMIN_ENDPOINT } from '../authApi/adminApi';

// export const addReporter = async (formData) => {
//   try {
//     const token = localStorage.getItem('token');

//     const response = await axios.post(API_ADMIN_ENDPOINT.ADD_REPORTER, formData, {
//       headers: {
//         'Content-Type': 'multipart/form-data',  // Important if profileImage is file
//         Authorization: `Bearer ${token}`,
//       },
//     });

//     return response.data;
//   } catch (error) {
//     console.error("Error in addReporter:", error.response?.data || error.message);
//     throw error;
//   }
// };




// const token = localStorage.getItem('token');
// const headers = {
//   Authorization: `Bearer ${token}`,
//   'Content-Type': 'application/json',
// };

// // ✅ Add Headline
// export const addHeadline = async (formData) => {
//    try {
//   const response = await axios.post(API_ADMIN_ENDPOINT.ADD_HEADLINE, formData, { headers });
//   return response.data;
//   } catch (error) {
//     console.error("Error in addHeadline:", error.response?.data || error.message);
//     throw error;
//   }
// };

// // ✅ Get All Headlines
// export const getHeadlines = async () => {
//   try {
//   const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_HEADLINES, { headers });
//   return response.data;
//   } catch (error) {
//     console.error("Error in getHeadlines:", error.response?.data || error.message);
//     throw error;
//   }
// };

// // ✅ Update Headline by ID
// export const updateHeadline = async (headlineId, formData) => {
//   const response = await axios.put(API_ADMIN_ENDPOINT.UPDATE_HEADLINE(headlineId), formData, { headers });
//   return response.data;
// };

// // ✅ Get Headline By ID (for edit)
// export const getHeadlineById = async (headlineId) => {
//   const response = await axios.get(API_ADMIN_ENDPOINT.GET_HEADLINE_BY_ID(headlineId), { headers });
//   return response.data;
// };


// export const deleteHeadline = async (headlineId) => {

//   const response = await axios.delete(API_ADMIN_ENDPOINT.DELETE_HEADLINE(headlineId), { headers });
//   return response.data;
// };


// src/api/adminService.js (Recommended structure)

import axios from 'axios';
import { API_ADMIN_ENDPOINT } from '../authApi/adminApi';
import fileDownload from "js-file-download";
// Helper function to get the current token dynamically from localStorage
const getToken = () => localStorage.getItem('token');

// Helper to create authorized headers for JSON data dynamically
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`, // Har baar latest token fetch hoga
    'Content-Type': 'application/json',
  },  
});

// Helper to create authorized headers for FormData dynamically
const getAuthHeadersForFormData = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`, // Har baar latest token fetch hoga
  },
});





// adminApi.js mein ye add karein
export const getDashboardStats = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_DASHBOARD_STATS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching dashboard stats:", error.response?.data || error.message);
    throw error;
  }
};

// --- REPORTER (Admin adding reporter) ---
export const addReporter = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.ADD_REPORTER, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error in addReporter:", error.response?.data || error.message);
    throw error;
  }
};

// --- HEADLINE Management ---
export const addHeadline = async (formData) => {
   try {
  const response = await axios.post(API_ADMIN_ENDPOINT.ADD_HEADLINE, formData, getAuthHeaders()); // Call getAuthHeaders()
  return response.data;
  } catch (error) {
    console.error("Error in addHeadline:", error.response?.data || error.message);
    throw error;
  }
};

export const getHeadlines = async () => {
  try {
  const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_HEADLINES, getAuthHeaders()); // Call getAuthHeaders()
  return response.data;
  } catch (error) {
    console.error("Error in getHeadlines:", error.response?.data || error.message);
    throw error;
  }
};

export const updateHeadline = async (headlineId, formData) => {
  try {
    const response = await axios.put(API_ADMIN_ENDPOINT.UPDATE_HEADLINE(headlineId), formData, getAuthHeaders()); // Call getAuthHeaders()
    return response.data;
  } catch (error) {
    console.error("Error in updateHeadline:", error.response?.data || error.message);
    throw error;
  }
};

export const getHeadlineById = async (headlineId) => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_HEADLINE_BY_ID(headlineId), getAuthHeaders()); // Call getAuthHeaders()
    return response.data;
  } catch (error) {
    console.error("Error in getHeadlineById:", error.response?.data || error.message);
    throw error;
  }
};

export const deleteHeadline = async (headlineId) => {
  try {
    const response = await axios.delete(API_ADMIN_ENDPOINT.DELETE_HEADLINE(headlineId), getAuthHeaders()); // Call getAuthHeaders()
    return response.data;
  } catch (error) {
    console.error("Error in deleteHeadline:", error.response?.data || error.message);
    throw error;
  }
};


// --- NEWS Management ---

export const getAllNews = async (params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_ADMIN_ENDPOINT.GET_ALL_NEWS}${queryString ? `?${queryString}` : ''}`;
    const response = await axios.get(url, getAuthHeaders()); // Call getAuthHeaders()
    return response.data;
  } catch (error) {
    console.error("Error in getAllNews:", error.response?.data || error.message);
    throw error;
  }
};



export const updateNews = async (newsId, updateData, hasMedia = false) => {
  try {
    const headers = hasMedia ? getAuthHeadersForFormData() : getAuthHeaders(); // Call getAuthHeaders() / getAuthHeadersForFormData()
    const response = await axios.put(API_ADMIN_ENDPOINT.UPDATE_NEWS(newsId), updateData, headers);
    return response.data;
  } catch (error) {
    console.error(`Error in updateNews (ID: ${newsId}):`, error.response?.data || error.message);
    throw error;
  }
};

export const getNewsById = async (newsId) => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_NEWS_BY_ID(newsId), getAuthHeaders()); // Call getAuthHeaders()
    return response.data;
  } catch (error) {
    console.error(`Error in getNewsById (ID: ${newsId}):`, error.response?.data || error.message);
    throw error;
  }
};

export const deleteNews = async (newsId) => {
  try {
    const response = await axios.delete(API_ADMIN_ENDPOINT.DELETE_NEWS(newsId), getAuthHeaders()); // Call getAuthHeaders()
    return response.data;
  } catch (error) {
    console.error(`Error in deleteNews (ID: ${newsId}):`, error.response?.data || error.message);
    throw error;
  }
};

export const bulkDeleteNews = async (payload) => {
  try {
    const response = await axios.delete(API_ADMIN_ENDPOINT.BULK_DELETE_NEWS, {
      ...getAuthHeaders(),
      data: payload, // Axios delete me body aise bhejni padti hai
    });
    return response.data;
  } catch (error) {
    console.error("Error in bulkDeleteNews:", error.response?.data || error.message);
    throw error;
  }
};

export const previewBulkNews = async (data) => {
  try {
    const response = await axios.post(
      API_ADMIN_ENDPOINT.BULK_NEWS_PREVIEW,
      data,
      getAuthHeaders()
    );

    return response.data;

  } catch (error) {
    console.error("Preview error:", error.response?.data || error.message);
    throw error;
  }
};


export const getAllReporters = async () => {
  try {
    // सुनिश्चित करें कि API_ADMIN_ENDPOINT.GET_ALL_REPORTERS आपके backend route '/api/admin/reporters' पर इंगित करता है
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_REPORTERS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getAllReporters:", error.response?.data || error.message);
    throw error;
  }
};

// services/adminService.js




export const deleteReporterById = async (id) => {
  try {
    const response = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_REPORTER}/${id}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in deleteReporterById:", error.response?.data || error.message);
    throw error;
  }
};

export const updateReporterById = async (id, payload) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_REPORTER}/${id}`, payload, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in updateReporterById:", error.response?.data || error.message);
    throw error;
  }
};
 


// Base URL for your backend API
const API_URL = '/https://117pw42t-4000.inc1.devtunnels.ms/api/v1/admin'; // Adjust if your API URL is different (e.g., 'http://localhost:5000/api/shorts')

// Function to get common headers with token
const getConfig = () => {
  const token = localStorage.getItem('token'); // Assuming you store token in localStorage
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      // 'Content-Type': 'multipart/form-data' is NOT needed for FormData, axios sets it automatically
    },
  };
};



export const createShort = async (formData) => {
  try {
    const response = await axios.post(
    API_ADMIN_ENDPOINT.CREATE_SHORT,
      formData,
      getAuthHeadersForFormData()   // ✅ sirf Authorization bhejega
    );
    return response.data;
  } catch (error) {
    console.error("Failed to create short:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error creating short" };
  }
};

export const getMyShorts = async (page = 1, limit = 10) => {
  try {
    const response = await axios.get(
      `${API_ADMIN_ENDPOINT.GET_MY_SHORTS}?page=${page}&limit=${limit}`,
      getAuthHeaders() // ✅ GET request ke liye normal JSON headers
    );
    return response.data;
  } catch (error) {
    console.error("Failed to fetch my shorts:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error fetching shorts" };
  }
};

// 2. Delete Short (DELETE Request)
export const deleteShort = async (id) => {
  try {
    const response = await axios.delete(
      `${API_ADMIN_ENDPOINT.DELETE_SHORT}/${id}`,
      getAuthHeaders() // ✅ Delete ke liye normal headers
    );
    return response.data;
  } catch (error) {
    console.error("Failed to delete short:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error deleting short" };
  }
};

// 3. Update Short (PUT Request with FormData)
export const updateShort = async (id, formData) => {
  try {
    const response = await axios.put(
      `${API_ADMIN_ENDPOINT.UPDATE_SHORT}/${id}`,
      formData,
      getAuthHeadersForFormData() // ✅ FormData bhejna hai isliye ye header use hoga
    );
    return response.data;
  } catch (error) {
    console.error("Failed to update short:", error.response?.data || error.message);
    throw error?.response?.data || { message: "Error updating short" };
  }
};

// // Get all shorts
// const getShorts = async (queryParams = '') => {
//   const response = await axios.get(`${API_URL}?${queryParams}`);
//   return response.data;
// };

// // Get a single short by ID
// const getShortById = async (id) => {
//   const response = await axios.get(`${API_URL}/${id}`);
//   return response.data;
// };

// // Update a short
// const updateShort = async (id, shortData) => {
//   // shortData should be a FormData object
//   const response = await axios.put(`${API_URL}/${id}`, shortData, getConfig());
//   return response.data;
// };

// // Delete a short
// const deleteShort = async (id) => {
//   const response = await axios.delete(`${API_URL}/${id}`, getConfig());
//   return response.data;
// };

// Like/Unlike a short
const likeShort = async (shortId) => {
  const response = await axios.post(`${API_URL}/${shortId}/like`, {}, getConfig());
  return response.data;
};

// Add a comment to a short
const addCommentToShort = async (shortId, commentText) => {
  const response = await axios.post(`${API_URL}/${shortId}/comment`, { text: commentText }, getConfig());
  return response.data;
};

const shortsService = {
  createShort,
  // getShorts,
  // getShortById,
  updateShort,
  deleteShort,
  likeShort,
  addCommentToShort,
};

export default shortsService;





export const getAllPolls = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_POLLS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getAllPolls:", error.response?.data || error.message);
    throw error;
  }
};

// Create a poll
export const createPoll = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_POLL, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error in createPoll:", error.response?.data || error.message);
    throw error;
  }
};

// Update poll
export const updatePoll = async (pollId, formData) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_POLL}/${pollId}`, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error in updatePoll:", error.response?.data || error.message);
    throw error;
  }
};


// adminService.js
export const deletePoll = async (pollId) => {
  try {
    const response = await axios.delete(
      `${API_ADMIN_ENDPOINT.DELETE_POLL}/${pollId}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error in deletePoll:", error.response?.data || error.message);
    throw error;
  }
};

// Vote on poll
export const voteOnPoll = async (pollId, optionIndex) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.VOTE_ON_POLL}/${pollId}`, { optionIndex }, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in voteOnPoll:", error.response?.data || error.message);
    throw error;
  }
};

// Deactivate poll
export const deactivatePoll = async (pollId) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.DEACTIVATE_POLL}/${pollId}`, {}, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in deactivatePoll:", error.response?.data || error.message);
    throw error;
  }
};

// Get poll results
export const getPollResults = async (pollId) => {
  try {
    const response = await axios.get(`${API_ADMIN_ENDPOINT.GET_POLL_RESULTS}/${pollId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getPollResults:", error.response?.data || error.message);
    throw error;
  }
};





// Get all videos
export const getAllVideos = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_VIDEOS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getAllVideos:", error.response?.data || error.message);
    throw error;
  }
};

// Create a video
export const createVideo = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_VIDEO, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error in createVideo:", error.response?.data || error.message);
    throw error;
  }
};

// Update a video
export const updateVideo = async (videoId, formData) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_VIDEO}/${videoId}`, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error in updateVideo:", error.response?.data || error.message);
    throw error;
  }
};

// Delete a video
export const deleteVideo = async (videoId) => {
  try {
    const response = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_VIDEO}/${videoId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in deleteVideo:", error.response?.data || error.message);
    throw error;
  }
};




// ✅ Create Tag
export const createTag = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_TAG, formData, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in createTag:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get All Tags
export const getAllTags = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_TAGS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getAllTags:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Update Tag
export const updateTag = async (tagId, formData) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_TAG}/${tagId}`, formData, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in updateTag:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Delete Tag
export const deleteTag = async (tagId) => {
  try {
    const response = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_TAG}/${tagId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in deleteTag:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get Trending Tags
export const getTrendingTags = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_TRENDING_TAGS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getTrendingTags:", error.response?.data || error.message);
    throw error;
  }
};




// ✅ Create Category
export const createCategory = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_CATEGORY, formData, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in createCategory:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get All Categories
export const getAllCategories = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_CATEGORIES, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getAllCategories:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get Category By ID
export const getCategoryById = async (categoryId) => {
  try {
    const response = await axios.get(`${API_ADMIN_ENDPOINT.GET_CATEGORY_BY_ID}/${categoryId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getCategoryById:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Update Category
export const updateCategory = async (categoryId, formData) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_CATEGORY}/${categoryId}`, formData, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in updateCategory:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Delete Category
export const deleteCategory = async (categoryId) => {
  try {
    const response = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_CATEGORY}/${categoryId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in deleteCategory:", error.response?.data || error.message);
    throw error;
  }
};


// ✅ Create SubCategory
export const createSubCategory = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_SUBCATEGORY, formData, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in createSubCategory:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get All SubCategories
export const getAllSubCategories = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_SUBCATEGORIES, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getAllSubCategories:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get SubCategories by CategoryId
export const getSubCategoriesByCategory = async (categoryId) => {
  try {
    const response = await axios.get(`${API_ADMIN_ENDPOINT.GET_SUBCATEGORY_BY_CATEGORY}/${categoryId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getSubCategoriesByCategory:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get SubCategory by Id
export const getSubCategoryById = async (subCategoryId) => {
  try {
    const response = await axios.get(`${API_ADMIN_ENDPOINT.GET_SUBCATEGORY_BY_ID}/${subCategoryId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getSubCategoryById:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Update SubCategory
export const updateSubCategory = async (subCategoryId, formData) => {
  try {
    const response = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_SUBCATEGORY}/${subCategoryId}`, formData, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in updateSubCategory:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Delete SubCategory
export const deleteSubCategory = async (subCategoryId) => {
  try {
    const response = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_SUBCATEGORY}/${subCategoryId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in deleteSubCategory:", error.response?.data || error.message);
    throw error;
  }
};



// ✅ Admin sets selected category (CategoryNews)
export const setCategoryNews = async (categoryIds) => {
  try {
    const response = await axios.post(
      API_ADMIN_ENDPOINT.SET_CATEGORY_NEWS,
      { categoryIds },
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error in setCategoryNews:", error.response?.data || error.message);
    throw error;
  }
};


// ✅ Get selected category and its news
export const getCategoryNews = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_CATEGORY_NEWS, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error in getCategoryNews:", error.response?.data || error.message);
    throw error;
  }
};

export const createNewsbyAdmin = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_NEWS, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error creating news:", error.response?.data || error.message);
    throw error;
  }
};

export const getMyNews = async (params = {}) => {
  try {
    // Build query string from params
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_ADMIN_ENDPOINT.GET_MY_NEWS}?${queryString}`;

    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching reporter's news:", error.response?.data || error.message);
    throw error;
  }
};


export const getAllAdminNews = async (params = {}) => {
  try {
    // Build query string from params
    const queryString = new URLSearchParams(params).toString();
    const url = `${API_ADMIN_ENDPOINT.GET_ALL_ADMIN_NEWS}?${queryString}`;

    const response = await axios.get(url, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching reporter's news:", error.response?.data || error.message);
    throw error;
  }
};

export const updateNewsStatus = async (id, status) => {
  try {
    const response = await axios.patch(
      API_ADMIN_ENDPOINT.UPDATE_NEWS_STATUS(id),
      { status },
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createStory = async (formData) => {
  try {
    const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_STORY, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) {
    console.error("Error creating story:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get All Stories
export const getAllStories = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_STORIES, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching stories:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Get Story By ID
export const getStoryById = async (storyId) => {
  try {
    const response = await axios.get(`${API_ADMIN_ENDPOINT.GET_STORY_BY_ID}/${storyId}`, getAuthHeaders());
    return response.data;
  } catch (error) {
    console.error("Error fetching story by ID:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ Add Slides to Existing Story
export const addSlidesToStory = async (storyId, formData) => {
  try {
    const response = await axios.post(`${API_ADMIN_ENDPOINT.ADD_SLIDES}/${storyId}`, formData, getAuthHeadersForFormData());
    return response.data;
  } catch (error) { 
    console.error("Error adding slides:", error.response?.data || error.message);
    throw error;
  }
};

// Delete a story by ID
export const deleteStory = async (storyId) => {
  try {
    const response = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_STORY}/${storyId}`, getAuthHeaders());
      return response.data;
    } catch (error) {
      console.error("Error deleting story:", error.response?.data || error.message);
      throw error;
    }
  };

  export const uploadMediaFiles = async (formData) => {
  try {
    const response = await axios.post(
      API_ADMIN_ENDPOINT.UPLOAD_MEDIA, // endpoint constant
      formData, // FormData object with files
      {
        headers: {
          ...getAuthHeaders().headers, // auth headers if needed
          "Content-Type": "multipart/form-data", // file upload ke liye zaroori
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error in uploadMedia:", error.response?.data || error.message);
    throw error;
  }
};


export const getAllAds = async () => {
    try {
        const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_ADS, getAuthHeaders());
        return response.data;
    } catch (error) {
        console.error("Error in getAllAds:", error.response?.data || error.message);
        throw error;
    }
};

export const createAd = async (adData) => {
    try {
        const response = await axios.post(API_ADMIN_ENDPOINT.CREATE_AD, adData, {
            ...getAuthHeaders(),
            headers: {
                ...getAuthHeaders().headers,
                'Content-Type': adData instanceof FormData ? 'multipart/form-data' : 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in createAd:", error.response?.data || error.message);
        throw error;
    }
};

export const updateAd = async (id, adData) => {
    try {
        const response = await axios.put(API_ADMIN_ENDPOINT.UPDATE_AD(id), adData, {
            ...getAuthHeaders(),
            headers: {
                ...getAuthHeaders().headers,
                'Content-Type': adData instanceof FormData ? 'multipart/form-data' : 'application/json',
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error in updateAd:", error.response?.data || error.message);
        throw error;
    }
};

export const deleteAd = async (id) => {
    try {
        const response = await axios.delete(API_ADMIN_ENDPOINT.DELETE_AD(id), getAuthHeaders());
        return response.data;
    } catch (error) {
        console.error("Error in deleteAd:", error.response?.data || error.message);
        throw error;
    }
};




// ✅ Categories
export const getAllCompanyCategories = async () => {
  try {
    const res = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_CompanyCATEGORIES, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in getAllCompanyCategories:", err.response?.data || err.message);
    throw err;
  }
};

export const createCompanyCategory = async (data) => {
  try {
    const res = await axios.post(API_ADMIN_ENDPOINT.CREATE_CompanyCATEGORY, data, {
            ...getAuthHeaders(),
            headers: {
                ...getAuthHeaders().headers,
                'Content-Type': data instanceof FormData ? 'multipart/form-data' : 'application/json',
            },
        });
    return res.data;
  } catch (err) {
    console.error("Error in createCompanyCategory:", err.response?.data || err.message);
    throw err;
  }
};

// export const updateCompanyCategory = async (id, data) => {
//   try {
//     const res = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_CompanyCATEGORY}/${id}`, data, getAuthHeaders());
//     return res.data;
//   } catch (err) {
//     console.error("Error in updateCompanyCategory:", err.response?.data || err.message);
//     throw err;
//   }
// };

export const updateCompanyCategory = async (id, data) => {
  try {
    const res = await axios.put(
      `${API_ADMIN_ENDPOINT.UPDATE_CompanyCATEGORY}/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`, 
          "Content-Type": "multipart/form-data", // 👈 important
        },
      }
    );
    return res.data;
  } catch (err) {
    console.error("Error in updateCompanyCategory:", err.response?.data || err.message);
    throw err;
  }
};


export const deleteCompanyCategory = async (id) => {
  try {
    const res = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_CompanyCATEGORY}/${id}`, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in deleteCompanyCategory:", err.response?.data || err.message);
    throw err;
  }
};


// SubCategories
export const getAllCompanySubCategories = async () => {
  try {
    const res = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_CompanySUBCATEGORIES, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in getAllCompanySubCategories:", err.response?.data || err.message);
    throw err;
  }
};

export const createCompanySubCategory = async (data) => {
  try {
    const res = await axios.post(API_ADMIN_ENDPOINT.CREATE_CompanySUBCATEGORY, data, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in createCompanySubCategory:", err.response?.data || err.message);
    throw err;
  }
};

export const updateCompanySubCategory = async (id, data) => {
  try {
    const res = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_CompanySUBCATEGORY}/${id}`, data, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in updateCompanySubCategory:", err.response?.data || err.message);
    throw err;
  }
};

export const deleteCompanySubCategory = async (id) => {
  try {
    const res = await axios.delete(`${API_ADMIN_ENDPOINT.DELETE_CompanySUBCATEGORY}/${id}`, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in deleteCompanySubCategory:", err.response?.data || err.message);
    throw err;
  }
};




// ✅ Get all companies
export const getAllCompanies = async () => {
  try {
    const res = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_COMPANIES, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in getAllCompanies:", err.response?.data || err.message);
    throw err;
  }
};

// ✅ Approve company
export const approveCompany = async (companyId) => {
  try {
    const res = await axios.put(
      `${API_ADMIN_ENDPOINT.APPROVE_COMPANY}/${companyId}`,
      {}, // No body needed for a PUT request if just updating a boolean flag
      getAuthHeaders()
    );
    return res.data;
  } catch (err) {
    console.error("Error in approveCompany:", err.response?.data || err.message);
    throw err;
  }
};

// ✅ Reject/Delete company
export const rejectCompany = async (companyId) => {
  try {
    const res = await axios.delete(
      `${API_ADMIN_ENDPOINT.REJECT_COMPANY}/${companyId}`,
      getAuthHeaders()
    );
    return res.data;
  } catch (err) {
    console.error("Error in rejectCompany:", err.response?.data || err.message);
    throw err;
  }
};



export const updateCompany = async (companyId, data) => {
  try {
    const res = await axios.put(`${API_ADMIN_ENDPOINT.UPDATE_COMPANY_DETAILS}/${companyId}`, data, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in updateCompany:", err.response?.data || err.message);
    throw err;
  }
};

export const getCompaniesByCategory = async (categoryId) => { /* ... */
  try {
    const res = await axios.get(`${API_ADMIN_ENDPOINT.GET_COMPANIES_BY_CATEGORY}/${categoryId}`, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in getCompaniesByCategory:", err.response?.data || err.message);
    throw err;
  }
};



export const getPendingCompanyUpdates = async () => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_PENDING_UPDATES, getAuthHeaders());
    return response.data;
  } catch (err) {
    console.error("Error in getPendingCompanyUpdates:", err.response?.data || err.message);
    throw err;
  }
};

// Admin: Approve a company's pending profile update
export const approveCompanyProfileUpdate = async (companyId) => { // Renamed to avoid clash
  try {
    const response = await axios.put(
      `${API_ADMIN_ENDPOINT.APPROVE_COMPANY_UPDATE}/${companyId}`,
      {}, // No body needed, changes are applied on the backend
      getAuthHeaders()
    );
    return response.data;
  } catch (err) {
    console.error("Error in approveCompanyProfileUpdate:", err.response?.data || err.message);
    throw err;
  }
};

// Admin: Reject a company's pending profile update
export const rejectCompanyProfileUpdate = async (companyId) => { // Renamed to avoid clash
  try {
    const response = await axios.put( // Backend function is PUT, not DELETE
      `${API_ADMIN_ENDPOINT.REJECT_COMPANY_UPDATE}/${companyId}`,
      {}, // No body needed
      getAuthHeaders()
    );
    return response.data;
  } catch (err) {
    console.error("Error in rejectCompanyProfileUpdate:", err.response?.data || err.message);
    throw err;
  }
};



export const getAllProductsForAdmin = async (filters = {}) => {
  try {
    const queryString = new URLSearchParams(filters).toString();
    const url = `${API_ADMIN_ENDPOINT.GET_ALL_PRODUCTS_ADMIN}${queryString ? `?${queryString}` : ''}`;
    const res = await axios.get(url, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in getAllProductsForAdmin:", err.response?.data || err.message);
    throw err;
  }
};

// Admin: Approve a product (also handles pending_delete)
export const approveProductAdmin = async (productId) => {
  try {
    const res = await axios.put(`${API_ADMIN_ENDPOINT.APPROVE_PRODUCT_ADMIN}/${productId}`, {}, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in approveProductAdmin:", err.response?.data || err.message);
    throw err;
  }
};

// Admin: Reject a product
export const rejectProductAdmin = async (productId, rejectionReason) => {
  try {
    const res = await axios.put(`${API_ADMIN_ENDPOINT.REJECT_PRODUCT_ADMIN}/${productId}`, { rejectionReason }, getAuthHeaders());
    return res.data;
  } catch (err) {
    console.error("Error in rejectProductAdmin:", err.response?.data || err.message);
    throw err;
  }
};

// Admin: Direct Delete a product (NEW backend endpoint assumed)
// This will directly delete an approved product without needing a pending_delete status.
export const adminDeleteProduct = async (productId) => {
    try {
        const res = await axios.delete(`${API_ADMIN_ENDPOINT.ADMIN_DELETE_PRODUCT}/${productId}`, getAuthHeaders());
        return res.data;
    } catch (err) {
        console.error("Error in adminDeleteProduct:", err.response?.data || err.message);
        throw err;
    }
};


// export const downloadNewsPDF = async (startDate, endDate) => {
//   const token = localStorage.getItem("token");
//   const response = await axios.get(
//     `${API_ADMIN_ENDPOINT.DOWNLOAD_NEWS_PDF}?startDate=${startDate}&endDate=${endDate}`,
//     {
//       headers: { Authorization: `Bearer ${token}` },
//       responseType: "blob", // ✅ Important for file download
//     }
//   );

//   const url = window.URL.createObjectURL(new Blob([response.data]));
//   const link = document.createElement("a");
//   link.href = url;
//   link.setAttribute("download", `News_Report_${startDate}_to_${endDate}.pdf`);
//   document.body.appendChild(link);
//   link.click();
// };



// export const downloadNewsPDF = async (startDate, endDate) => {
//   try {
//     const res = await axios.get(
//        `${API_ADMIN_ENDPOINT.DOWNLOAD_NEWS_PDF}?startDate=${startDate}&endDate=${endDate}`,
//       {
//         responseType: "blob", // important for binary files
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       }
//     );

//     const fileName = `News_Report_${startDate}_to_${endDate}.pdf`;
//     fileDownload(res.data, fileName);
//   } catch (error) {
//     console.error("Download failed:", error);
//     alert(error.response?.data?.message || "Failed to download PDF");
//   }
// };


export const downloadNewsPDF = async (startDate, endDate, language) => { // ✅ 'language' पैरामीटर जोड़ा गया
  try {
    const res = await axios.get(
       // ✅ URL में 'language' क्वेरी पैरामीटर जोड़ा गया
       `${API_ADMIN_ENDPOINT.DOWNLOAD_NEWS_PDF}?startDate=${startDate}&endDate=${endDate}&language=${language}`,
      {
        responseType: "blob", // important for binary files
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );

    // ✅ फ़ाइल नाम में भाषा शामिल करना ताकि यह विशिष्ट हो
    const fileName = `News_Report_${startDate}_to_${endDate}_${language}.pdf`;
    fileDownload(res.data, fileName);
  } catch (error) {
    console.error("Download failed:", error);
    // यह सुनिश्चित करने के लिए कि सर्वर से विशिष्ट त्रुटि संदेश प्रदर्शित हो
    if (error.response && error.response.data) {
      // यदि error.response.data एक Blob है, तो उसे टेक्स्ट के रूप में पढ़ें
      const reader = new FileReader();
      reader.onload = function() {
        try {
          const errorData = JSON.parse(reader.result);
          alert(errorData.message || "Failed to download PDF");
        } catch (e) {
          alert("Failed to download PDF: " + reader.result);
        }
      };
      reader.readAsText(error.response.data);
    } else {
      alert(error.message || "Failed to download PDF");
    }
  }
};






// export const createLiveNews = async (formData) => {
//   try {
//     const response = await axios.post(
//       API_ADMIN_ENDPOINT.CREATE_LIVE_NEWS,
//       formData,
//      getAuthHeadersForFormData() 
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error creating live news:", error.response?.data || error.message);
//     throw error;
//   }
// };



// export const addLiveUpdate = async (liveNewsId, formData) => {
//   try {
 

//     const response = await axios.post(
//       `${API_ADMIN_ENDPOINT.UPDATE_LIVE_NEWS}/${liveNewsId}`, // Adjust this endpoint as per your routes
//       formData,
//       getAuthHeadersForFormData() // Essential for sending files (media)
//     );
//     return response.data;
//   } catch (error) {
//     console.error("Error adding live update:", error.response?.data || error.message);
//     throw error;
//   }
// };




// // ✅ GET LIVE NEWS BY ID
// export const getLiveNewsById = async (id) => {
//   try{

//     const response = await axios.get(`${API_ADMIN_ENDPOINT}/getLiveNews/${id}`, getAuthHeaders());
//   return response.data;
//   } 
  
// catch (error) {
//     console.error("Error adding live update:", error.response?.data || error.message);
//     throw error;
//   }
// };

// // ✅ END LIVE NEWS
// export const endLiveNews = async (id) => {
//   return await axios.put(`${API_ADMIN_ENDPOINT}/live-news/end/${id}`, {}, getAuthHeaders());
// };


// export const getRunningLiveNews = async (params = {}) => {
//   try {
//     // The backend `getAllLiveNews` controller already has { status: { $ne: "ended" } }
//     // So this endpoint naturally fetches running news.
//     const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_LIVE_NEWS, {
//       params, // Allows passing query parameters like category, search, limit, page
//       ...getAuthHeaders(), // Include auth headers
//     });
//     return response.data;
//   } catch (error) {
//     console.error("Error fetching running live news list:", error.response?.data || error.message);
//     throw error;
//   }
// };

export const createLiveNews = async (formData) => {
  try {
    const response = await axios.post(
      API_ADMIN_ENDPOINT.CREATE_LIVE_NEWS,
      formData,
      getAuthHeadersForFormData()
    );
    return response.data;
  } catch (error) {
    console.error("Error creating live news:", error.response?.data || error.message);
    throw error;
  }
};


export const addLiveUpdate = async (liveNewsId, formData) => {
  try {
    const response = await axios.post(
      // Corrected to use the specific ADD_LIVE_UPDATE endpoint
      `${API_ADMIN_ENDPOINT.ADD_LIVE_UPDATE}/${liveNewsId}`,
      formData,
      getAuthHeadersForFormData()
    );
    return response.data;
  } catch (error) {
    console.error("Error adding live update:", error.response?.data || error.message);
    throw error;
  }
};


// ✅ GET LIVE NEWS BY ID (Corrected)
export const getLiveNewsById = async (id) => {
  try {
    const response = await axios.get(
      // Corrected to use the specific GET_LIVE_NEWS_BY_ID endpoint
      `${API_ADMIN_ENDPOINT.GET_LIVE_NEWS_BY_ID}/${id}`,
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching live news by ID:", error.response?.data || error.message);
    throw error;
  }
};

// ✅ END LIVE NEWS (Corrected endpoint and method to match backend router.post)
export const endLiveNews = async (id) => {
  try {
    // Backend router.post("/endLiveNews/:id", ...) expects a POST request
    const response = await axios.post(
      `${API_ADMIN_ENDPOINT.END_LIVE_NEWS}/${id}`,
      {}, // Empty body for POST request as per your backend controller
      getAuthHeaders()
    );
    return response.data;
  } catch (error) {
    console.error("Error ending live news:", error.response?.data || error.message);
    throw error;
  }
};


export const getRunningLiveNews = async (params = {}) => {
  try {
    const response = await axios.get(API_ADMIN_ENDPOINT.GET_ALL_LIVE_NEWS, {
      params,
      ...getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching running live news list:", error.response?.data || error.message);
    throw error;
  }
};